import * as Yup from 'yup';

export const validationTematica = Yup.object({
    txtNombre: Yup.string().min(3,'Minimo 3 caracteres').max(100, 'Maximo 100 caracteres').required('Requerido'),
    txtDescripcion: Yup.string().min(3,'Minimo 3 caracteres').max(500, 'Maximo 500 caracteres').required('Requerido'),
});